import { createIcon } from "@chakra-ui/react";

export const Diamond = createIcon({
  displayName: "Fun",
  viewBox: "0 0 48 48",
  path: [
    <path d="M24 10.702v10.145l11.765-10.145H24z" fill="#98E5FF" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.816 21.25V10.518h12.446L23.815 21.25zm11.452-10.363H24.185v9.557l11.083-9.557z"
      fill="#2B2C3D"
    />,
    <path
      d="m35.765 10.702 3.576-3.194L48 16.902l-12.235-6.2z"
      fill="#98E5FF"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m48.136 16.777-.22.29-12.476-6.322 3.914-3.495 8.782 9.527zm-.965-.502-7.842-8.508-3.24 2.893 11.082 5.615z"
      fill="#2B2C3D"
    />,
    <path d="m48 16.902-10.541 3.945-1.694-10.145L48 16.902z" fill="#98E5FF" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m37.313 21.099-1.791-10.727 12.936 6.555L37.313 21.1zm10.227-4.223-11.534-5.844 1.597 9.564 9.938-3.72z"
      fill="#2B2C3D"
    />,
    <path d="M48 16.902 24 41.419l13.459-20.572L48 16.902z" fill="#00A4DB" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m47.288 17.366-9.708 3.633-12.394 18.945 22.102-22.578zm.844-.335-24 24.517-.287-.23 13.492-20.622 10.598-3.967.197.302z"
      fill="#2B2C3D"
    />,
    <path d="M35.765 10.702 24 20.847H37.46l-1.694-10.145z" fill="#00A4DB" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.677 21.032H23.503l12.39-10.684 1.784 10.684zm-.436-.37-1.604-9.606-11.14 9.606H37.24z"
      fill="#2B2C3D"
    />,
    <path d="M37.459 20.847 24 41.42V20.847H37.46z" fill="#98E5FF" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.815 42.039V20.663H37.8L23.815 42.039zm13.302-21.007H24.184V40.8l12.933-19.768z"
      fill="#2B2C3D"
    />,
    <path d="M24 10.702V6.193l10.162.654 1.603 3.855H24z" fill="#DDF9FF" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.041 10.887H23.815v-4.89l10.473.673 1.753 4.217zm-.553-.37-1.453-3.494-9.85-.633v4.127h11.303z"
      fill="#2B2C3D"
    />,
    <path
      d="m39.34 7.509-5.178-.662 1.602 3.856 3.577-3.194z"
      fill="#98E5FF"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m35.694 11.013-1.825-4.39 5.897.754-4.072 3.636zm3.222-3.372-4.461-.57 1.38 3.32 3.08-2.75z"
      fill="#2B2C3D"
    />,
    <path d="M24 10.702v10.145L12.235 10.702H24z" fill="#00A4DB" />,
    <path d="M12.235 10.702 8.66 7.508 0 16.902l12.235-6.2z" fill="#98E5FF" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m.083 17.067-.22-.29L8.647 7.25l3.914 3.495L.083 17.067zM11.91 10.66 8.67 7.767.83 16.275 11.91 10.66z"
      fill="#2B2C3D"
    />,
    <path d="m0 16.902 10.541 3.945 1.694-10.145L0 16.902z" fill="#00A4DB" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.686 21.099-.459 16.927l12.936-6.554-1.79 10.726zm-.29-.503 1.597-9.564L.459 16.876l9.937 3.72z"
      fill="#2B2C3D"
    />,
    <path d="m0 16.902 24 24.517-13.459-20.572-10.54-3.945z" fill="#00A4DB" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m24.154 41.318-.286.23-24-24.517.197-.302 10.597 3.967 13.492 20.622zm-1.34-1.374L10.419 20.999.712 17.366l22.102 22.578z"
      fill="#2B2C3D"
    />,
    <path d="M12.235 10.703 24 20.846H10.541l1.694-10.145z" fill="#98E5FF" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.497 21.032H10.323l1.784-10.684 12.39 10.684zm-.994-.37-11.14-9.605-1.604 9.606h12.744z"
      fill="#2B2C3D"
    />,
    <path d="M10.541 20.847 24 41.42V20.847H10.541z" fill="#00A4DB" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.185 42.039 10.2 20.663h13.985v21.376zm-.37-1.24V21.033H10.883L23.815 40.8z"
      fill="#2B2C3D"
    />,
    <path
      d="m24 10.703 3.012-2.255L24 6.194l-10.162.653-1.603 3.856H24z"
      fill="#DDF9FF"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.062 10.887H11.959l1.753-4.217 10.344-.665 3.264 2.443-3.258 2.44zm-.123-.369 2.765-2.07-2.76-2.066-9.98.642-1.452 3.494H23.94z"
      fill="#2B2C3D"
    />,
    <path d="m8.659 7.509 5.179-.662-1.603 3.855L8.66 7.51z" fill="#98E5FF" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.306 11.013 8.234 7.377l5.897-.754-1.825 4.39zm-.141-.621 1.38-3.321-4.461.57 3.08 2.75z"
      fill="#2B2C3D"
    />,
    <path d="M24 20.847V10.702H12.235L24 20.847z" fill="#98E5FF" />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.185 21.25 11.739 10.518h12.446V21.25zm-.37-.806v-9.557H12.732l11.083 9.557z"
      fill="#2B2C3D"
    />,
    <path
      d="m36 7.986-.651 2.067-2.071.65 2.07.649.652 2.067.65-2.067 2.072-.65-2.071-.65L36 7.987z"
      fill="#fff"
    />,
  ],
  defaultProps: {
    "aria-label": "A blue diamond"
  }
});

export default Diamond;
